import { VlWindow } from '../types';

declare const window: VlWindow;

interface CanvasEnvResponse {
  AWS_XRAY_ACCESS_KEY_ID?: string;
  AWS_XRAY_SECRET_ACCESS_KEY?: string;
  AWS_XRAY_REGION?: string;
  AWS_XRAY_SESSION_TOKEN?: string;
}

async function initXRay(): Promise<void> {
  if (!window.doCanvasCall) {
    return;
  }

  try {
    const response = await window.doCanvasCall('env', null);
    const result: CanvasEnvResponse = JSON.parse(response);

    window.AWS_XRAY_ACCESS_KEY_ID = result.AWS_XRAY_ACCESS_KEY_ID;
    window.AWS_XRAY_REGION = result.AWS_XRAY_REGION;
    window.AWS_XRAY_SECRET_ACCESS_KEY = result.AWS_XRAY_SECRET_ACCESS_KEY;
    window.AWS_XRAY_SESSION_TOKEN = result.AWS_XRAY_SESSION_TOKEN;
  } catch (e) {
    // Unable to retrieve XRay credentials
  }
}

export async function loadVeloceConfig(cb: () => void): Promise<void> {
  await initXRay();

  cb();
}
